import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { GraphApiService } from '../../shared/services/graph-api.service';
import { RoleService } from '../../shared/services/role.service';
import { EmployeeService, EmailPreferences } from '../../shared/services/employee.service';

@Component({
  selector: 'app-my-profile-landing-page',
  templateUrl: './my-profile-landing-page.component.html',
  styleUrls: ['./my-profile-landing-page.component.scss']
})
export class MyProfileLandingPageComponent implements OnInit {
  isDarkViewEnabled: boolean;
  userId: any;
  currentUser: any;
  isLoading: boolean;
  @HostBinding('class.dark-theme') isDarkThemeEnabled: boolean = false;
  isDashboardViewEnabled: boolean = false;
  user: AccountInfo | null;
  isDashbboardViewVisible: boolean = false;
  isVpThresholdApprover: boolean = false;
  isDirectorApprover: boolean = false;

  constructor(private authService: MsalService, private graphApiService: GraphApiService, private roleService: RoleService, private employeeService: EmployeeService) {
  }
  emailPrefs: EmailPreferences = {
    vpThreshold: true,
    directorApproval: true,
    seApproval: true,
    seComponentWorkflow: true,
    seApproved: true,
    contractSigned: true
  };

  ngOnInit() {
    this.isDarkThemeEnabled = false;
    this.isDashboardViewEnabled = false;
    this.isDashbboardViewVisible = false;
    this.isLoading = true;
    this.setupPermissions();
    this.getUser();
    this.getStorageValues();
    this.loadEmailPrefs();
    this.loadApproverVisibility();
  }

  getActiveAccount() {
    return this.authService.instance.getActiveAccount();
  }

  setupPermissions() {
    this.user = this.authService.instance.getActiveAccount();
    this.userId = this.user?.localAccountId;
    if (this.hasRole('PortalSEPostsalesEngineerSA') || this.hasRole('Projects.Approver') || this.hasRole('PortalAdmin') ||
      this.hasRole('PortalSEDirector') || this.hasRole('PortalSEProjectManager') || this.hasRole('PortalSEPresalesArchitect') ||
      this.hasRole('PortalSEPostsalesEngineer') || this.hasRole('PortalSalesSupport') || this.hasRole('PortalSEProjectManagerOfficer') ||
      this.hasRole('ProfessionalServiceCoordinator')) {
      this.isDashbboardViewVisible = true;
    }
  }

  getStorageValues() {
    let darkTheme; let isEnabledDashboardView;
    var darkThemeLocalStorageValue = localStorage.getItem('useDarkTheme');
    var dashboardViewStorageValue = localStorage.getItem('isDashboardViewEnabled');
    if (darkThemeLocalStorageValue) {
      darkTheme = JSON.parse(darkThemeLocalStorageValue);
    }
    if (dashboardViewStorageValue) {
      isEnabledDashboardView = JSON.parse(dashboardViewStorageValue);
    }
    if (darkTheme) {
      this.isDarkThemeEnabled = darkTheme['useDarkTheme'];
    }
    if (isEnabledDashboardView)
      this.isDashboardViewEnabled = isEnabledDashboardView['isDashboardViewEnabled'];
  }

  loadEmailPrefs() {
    if (this.userId) {
      this.employeeService.getEmailPreferences(this.userId).subscribe({
        next: (prefs) => { this.emailPrefs = prefs; },
        error: (err) => { console.error('Failed to load email preferences:', err); }
      });
    }
  }

  getFontColor() {
    return !this.isDarkThemeEnabled ? 'theme' : 'dark-theme';
  }

  getUser() {
    if (this.userId) {
      this.graphApiService.getUser(this.userId).subscribe((data) => {
        this.currentUser = data;
        this.isLoading = false;
      })
    }
  }

  onEmailPrefChange() {
    if (this.userId) {
      this.employeeService.updateEmailPreferences(this.userId, this.emailPrefs).subscribe({
        next: () => { console.log('Email preferences saved to DB'); },
        error: (err) => { console.error('Failed to save email preferences:', err); }
      });
    }
  }

  loadApproverVisibility() {
    if (this.userId) {
      this.employeeService.isVpThresholdApprover(this.userId).subscribe({
        next: (result) => { this.isVpThresholdApprover = result; },
        error: (err) => { console.error('VP threshold check failed:', err); }
      });
      this.employeeService.isDirectorApprover(this.userId).subscribe({
        next: (result) => { this.isDirectorApprover = result; },
        error: (err) => { console.error('Director check failed:', err); }
      });
    }
  }

  getToolTipData() {
    return this.currentUser.mail;
  }

  flipTheme() {
    var obj = { 'useDarkTheme': this.isDarkThemeEnabled };
    localStorage.setItem('useDarkTheme', JSON.stringify(obj));
    location.reload();

  }

  toggleDashboardView() {
    var obj = { 'isDashboardViewEnabled': this.isDashboardViewEnabled };
    localStorage.setItem('isDashboardViewEnabled', JSON.stringify(obj));
    location.reload();
  }

  hasRole(role: string) {
    return this.roleService.checkRoleExists(role, this.user, false);
  }
}
